export default __webpack_public_path__ + "static/media/unknown-pert.764e7680.png";